(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6120],{

/***/ 19335:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...slug]]",
      function () {
        return __webpack_require__(35262);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 35262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ StaticPage; },
/* harmony export */   "getDataSets": function() { return /* binding */ getDataSets; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87394);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _components_Page__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97598);
/* harmony import */ var _contexts_PrefetchedDataContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52310);
/* harmony import */ var _components_RichTextHtml_RichTextHtml__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8841);





var __N_SSG = true;
function StaticPage(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_contexts_PrefetchedDataContext__WEBPACK_IMPORTED_MODULE_1__/* .PrefetchedDataContext.Provider */ .N.Provider, {
        value: props.prefetchedData,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Page__WEBPACK_IMPORTED_MODULE_2__/* .Page */ .T, {
            content: props.content
        })
    });
};
var getPropertiesByKey = function(content, propertyName) {
    var matchingProperties = [];
    var findMatchingProperties = function(element) {
        if (typeof element !== "object") return;
        if (Array.isArray(element)) {
            element.forEach(function(el) {
                return findMatchingProperties(el);
            });
            return;
        }
        Object.entries(element || {}).forEach(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
            if (key === propertyName) matchingProperties.push(value);
            findMatchingProperties(value);
        });
    };
    findMatchingProperties(content);
    return matchingProperties;
};
/**
 * Goes through content and finds all data-bindings that have been used within a block.
 * This is needed in order to only fetch data that is used in the data binding.
 */ var getDataSets = function(content) {
    var bindings = getPropertiesByKey(content, "bindings");
    var bindingMatches = bindings.flatMap(function(binding) {
        return Object.values(binding || {}).map(function(value) {
            return value === null || value === void 0 ? void 0 : value.matchAll(/state\.(currentAccount|user|userProfile|queryParameters)\./g);
        });
    });
    var dataSets = bindingMatches.reduce(function(acc, curr) {
        var dataSet = Array.from(curr).flat()[1];
        acc.set(dataSet, true);
        return acc;
    }, new Map());
    /**
   * Go through all component options and find all values surrounded by the data binding regex
   * and add the first value in the dot notation to the dataSets.
   */ getPropertiesByKey(content, "options").flatMap(function(options) {
        return Object.values(options).filter(function(option) {
            return !!option && typeof option === "string";
        });
    }).forEach(function(option) {
        if (typeof option !== "string") return;
        var matches = Array.from(option === null || option === void 0 ? void 0 : option.matchAll(_components_RichTextHtml_RichTextHtml__WEBPACK_IMPORTED_MODULE_4__/* .DATA_BINDING_REGEX */ .iY));
        if (matches.length) matches.forEach(function(match) {
            var ref, ref1, ref2;
            var isEscaped = !!(match === null || match === void 0 ? void 0 : match[1]);
            if (isEscaped) return;
            var key = (ref1 = match === null || match === void 0 ? void 0 : (ref = match[3]) === null || ref === void 0 ? void 0 : ref.split(".")) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.trim();
            dataSets.set(key, true);
        });
    });
    if (dataSets.size) return Object.fromEntries(dataSets);
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(19335); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);